import type { ClientGroup } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupApi } from '@/features/api/hooks/grapevine-group/useGrapevineGroupApi';

export const useGetGroups = () => {
  const api = useGrapevineGroupApi();

  const sortGroupsByName = useCallback(
    (groups: ClientGroup[]) =>
      [...groups].sort((a, b) =>
        a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())
      ),
    []
  );

  return useQuery({
    queryKey: [API_CACHE_KEYS.GROUPS],
    queryFn: () => api.getAllAvailableGroups(),
    select: sortGroupsByName
  });
};
